import React from 'react';
import { Icon } from './Icon.js';
export const IconRectLayoutGrid3Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M17,6.5v-1.75c0-1.517-1.233-2.75-2.75-2.75H3.75c-1.517,0-2.75,1.233-2.75,2.75v1.75H17Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("path", { d: "M7,8v8h7.25c1.517,0,2.75-1.233,2.75-2.75v-5.25H7Z", fill: "currentColor" }),
        React.createElement("path", { d: "M5.5,8H1v5.25c0,1.517,1.233,2.75,2.75,2.75h1.75V8Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconRectLayoutGrid3Fill18.js.map